import { Button } from '@sitewise/ui';

import { useSyncStore } from '../../../stores/sync-store.js';

/**
 * Phase 10 — surfaced as a small toast when the service worker
 * has staged a new bundle. Clicking "Reload" calls `skipWaiting`,
 * which triggers `controllerchange` in `register-sw.ts` and reloads
 * the page once the new worker takes control.
 */
export function PwaUpdateToast() {
  const updateReady = useSyncStore((s) => s.updateReady);
  const applyUpdate = useSyncStore((s) => s.applyUpdate);

  if (!updateReady) return null;

  function reload() {
    applyUpdate?.();
    // The installed worker may never claim this tab. Refresh anyway.
    window.setTimeout(() => window.location.reload(), 500);
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-16 right-4 z-50 flex max-w-sm items-center gap-3 rounded-md border border-border bg-surface-elevated px-4 py-3 shadow-lg"
    >
      <button type="button" onClick={reload} className="min-w-0 flex-1 text-left text-sm">
        <p className="font-medium text-fg">Update available</p>
        <p className="text-xs text-fg-muted">A newer version of SiteWise is ready.</p>
      </button>
      <Button size="sm" variant="outline" type="button" onClick={reload}>
        Reload
      </Button>
    </div>
  );
}
